module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-footer no-print"
  }, [(_vm.$route.name !== 'LocationSlug' && _vm.$route.name !== 'ReservationsSlug') ? _c('div', [_c('hr', {
    staticClass: "space xs border-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-content"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "sidebar-menu-item"
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#features'),
      expression: "'#features'"
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('home')
      }
    }
  }, [_vm._v("FEATURES & BENEFITS")])]), _vm._v(" "), _c('li', {
    staticClass: "sidebar-menu-item"
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contact_us'),
      expression: "'#contact_us'"
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('home')
      }
    }
  }, [_vm._v("CONTACT US")])]), _vm._v(" "), _c('li', {
    staticClass: "sidebar-menu-item"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('pages/terms')
      }
    }
  }, [_vm._v("TERMS OF USE")])]), _vm._v(" "), _c('li', {
    staticClass: "sidebar-menu-item"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('pages/privacy')
      }
    }
  }, [_vm._v("PRIVACY")])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('hr', {
    staticClass: "space xs"
  })]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("© "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("OpenCabana")]), _vm._v(", " + _vm._s(_vm.date) + ".")], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-group"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/opencabana/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.twitter.com/opencabana/"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/opencabana/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.youtube.com/channel/UC4guebgvIj1sTBwV4Da3tjg/"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7adc6a32!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Footer.vue
// module id = 604
// module chunks = 2